"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryOptionsService = void 0;
var constants_1 = require("../constants");
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var Language_service_1 = require("./Language.service");
var ApplicationApi_service_1 = require("./jsonServiceApi/ApplicationApi.service");
var DeliveryOptionsService = /** @class */ (function () {
    function DeliveryOptionsService(languageService, applicationApiService) {
        this.languageService = languageService;
        this.applicationApiService = applicationApiService;
    }
    /**
     * Get SystemDeliveryOptions from ApplicationInfo
     */
    DeliveryOptionsService.prototype.getSystemDeliveryOptions = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var applicationInfo;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.applicationApiService.getApplicationInfo()];
                    case 1:
                        applicationInfo = _c.sent();
                        return [2 /*return*/, (_b = (_a = applicationInfo === null || applicationInfo === void 0 ? void 0 : applicationInfo.ServiceResult) === null || _a === void 0 ? void 0 : _a.System) === null || _b === void 0 ? void 0 : _b.DeliveryOptions];
                }
            });
        });
    };
    /**
     * @deprecated
     * This function doesn't work as same as the one in fullbundle,
     * the patched `Label` is `string` which was `() => string` in fullbundle.
     *
     * We are going to remove it and please use `patchLabelForDeliveryOptions` instead.
     *
     * Transforms each delivery option's label to its translated version
     * @param deliveryOptions
     * @param languageCode
     */
    DeliveryOptionsService.prototype.applyTranslationForSystemDeliveryOptions = function (deliveryOptions, languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            var translations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languageService.getTranslations(languageCode || this.languageService.getLanguage(), 'ToolKit', 'Default')];
                    case 1:
                        translations = _a.sent();
                        deliveryOptions.forEach(function (option) {
                            // eslint-disable-next-line no-param-reassign
                            option.Label = translations[constants_1.DeliveryOptionsTypeToI18NKey[option.Type]] || option.Name;
                        });
                        return [2 /*return*/, deliveryOptions];
                }
            });
        });
    };
    /**
     * Transforms each delivery option's label to its translated version
     * @param deliveryOptions
     * @param languageCode
     */
    DeliveryOptionsService.prototype.patchLabelForDeliveryOptions = function (deliveryOptions, languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.applicationApiService.patchLabelForDeliveryOptions(deliveryOptions, languageCode)];
            });
        });
    };
    DeliveryOptionsService = __decorate([
        CommonService_decorator_1.CommonService('DeliveryOptionsService'),
        __metadata("design:paramtypes", [Language_service_1.LanguageService, ApplicationApi_service_1.ApplicationApiService])
    ], DeliveryOptionsService);
    return DeliveryOptionsService;
}());
exports.DeliveryOptionsService = DeliveryOptionsService;
//# sourceMappingURL=DeliveryOptions.service.js.map